module.exports = __webpack_public_path__ + "static/media/test13_3.3d4b587c.png";